<!--
* 组件名 : 左侧关闭按钮+分享
* 开发者 : HN
*
* 参数:  无
*
* 事件:  null
*
-->
<template>
  <nav class="menu-nav">
    <div class="nano" ref="nano">
      <div class="nano-content">
        <ul class="menu-list">
          <!-- 导航切换状态的主要思路是更改父级节点和子集节点的active值 -->
          <li
            v-for="(itemA, i) in aside"
            :class="['menu-item', isActive === i ? 'active' : '']"
            :key="i"
            ref="menuItem"
            @mouseover="on_mouse_over(i)"
            @mouseleave="on_mouse_leave()"
          >
            <span
              class="menu-label"
              @click="on_nav_click('', i, $event, itemA.slug)"
            >
              <span v-if="itemA.episode !== itemA.title">{{
                itemA.episode
              }}</span>
            </span>
            <!-- 子菜单  -->
            <dl class="menu-item-child" :class="{ year: i === 7 }">
              <dt
                class="menu-chapter"
                @click="on_nav_click('', i, $event, itemA.slug)"
              >
                {{ itemA.title | removeNum("、") }}
              </dt>
              <template v-if="itemA.children.length > 1">
                <dd
                  :class="[
                    isChildActive === j
                      ? 'menu-children childActive'
                      : 'menu-children',
                  ]"
                  v-for="(itemB, j) in itemA.children"
                  :key="j"
                  @click="on_nav_click(i, j, $event, itemA.slug, itemB.slug)"
                  v-html="itemB.title"
                />
              </template>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "menu-nav",
  computed: {
    ...mapState("global", ["isShowAside"]),
    ...mapGetters("global", ["aside"]),
  },
  data() {
    return {
      isActive: 0,
      isChildActive: 0,
    };
  },
  created() {},

  mounted() {
    // 初始化上下滚动
    $(this.$refs.nano).nanoScroller();

    this.change_active();
  },
  watch: {
    /**
     * 当前nav切换状态更新
     */
    $route: "change_active",
  },
  // 过滤器 https://cn.vuejs.org/v2/guide/filters.html
  filters: {
    removeNum(value, segmentation) {
      let arr = value.trim().split(segmentation);
      if (arr.length > 1) {
        return arr.slice(1).join(segmentation);
      } else {
        return arr[0];
      }
    },
  },
  methods: {
    ...mapMutations("global", ["updateIsShowAside", "updateIsCopyrightShow"]),

    // 路由切换更改菜单激活状态
    change_active() {
      this.aside.map((el, i) => {
        if (el.slug === this.$route.name) {
          this.$emit("changeMenuBg", i);
          this.isActive = i;
          this.isChildActive = "";
        } else {
          if (el.children.length > 1) {
            el.children.map((elc, j) => {
              if (elc.slug === this.$route.name) {
                this.$emit("changeMenuBg", i);
                this.isActive = i;
                this.isChildActive = j;
              }
            });
          }
        }
      });
    },

    // 点击事件
    on_nav_click(isChild, i, ev, ...slugArr) {
      if (isChild === "") {
        // 父阶段
        // 切换父阶段激活状态
        this.isActive = i;
        // 清空子阶段激活状态
        this.isChildActive = "";
      } else {
        // 切换父阶段激活状态
        this.isActive = isChild;
        // 子阶段
        this.isChildActive = i;
      }
      // 定位需要显示的背景图
      this.$emit("changeMenuBg", this.isActive);

      if (this.$route.name === slugArr[slugArr.length - 1]) {
        console.log("Error: 相同路由切换-1");
        this.updateIsShowAside();
      } else {
        this.updateIsShowAside();
        this.$router.push(`/${slugArr.join("/")}`);
      }
    },
    on_mouse_over(i) {
      this.$emit("changeMenuBg", i);
    },
    // 鼠标移出后把当前项还还原成点击事件确认的选项
    on_mouse_leave() {
      this.$emit("changeMenuBg", this.isActive);
    },
  },
};
</script>

<style lang="scss">
#menu {
  .menu-container {
    .menu-nav {
      position: absolute;
      top: 0;
      left: 19.3%;
      // 因为menu-label的文字是右对齐，填不满所以中文向左偏移77像素，
      // 外文可以视情况进行微调；
      // width: calc(63.6% + 77px);
      width: 80.7%;

      height: 100vh;
      opacity: 0;
      transform: translateX(-1vw);
      transition: all 500ms cubic-bezier(0.645, 0.045, 0.355, 1);

      transition-delay: 150ms;
      ul {
        list-style: none;
      }
      .nano > .nano-pane {
        width: 3px;
      }
      .menu-list {
        padding: 68px 0 100px 0;
        width: 810px;
        max-width: 810px;
        .menu-item {
          display: flex;
          justify-content: space-between;
          color: #fff;
          &:hover {
            .menu-label,
            .menu-label span,
            .menu-chapter {
              cursor: pointer;

              color: $color-navigation;
            }
          }
          &.active {
            .menu-label span,
            .menu-chapter {
              color: $color-navigation;
            }
            dd.childActive {
              color: $color-navigation;
            }
            .menu-item-child {
              &:after {
                height: 0;
              }
            }
            & ~ .menu-item {
              &:hover {
                .menu-label {
                  &:after {
                    background-color: $color-navigation;
                  }
                }
              }
              .menu-label {
                &:after {
                  width: 8px;
                  height: 8px;
                  background-color: #fff;
                  transform: translate(24px, -50%);
                }
              }
              .menu-item-child {
                &:after {
                  height: 0;
                }
              }
            }
          }
          &:last-of-type {
            .menu-item-child {
              &:before,
              &:after {
                display: none !important;
              }
            }
          }
          .menu-label {
            position: relative;
            font-size: 18px;
            line-height: 34px;
            min-width: 123px;
            height: 34px;
            margin-right: 20px;
            text-align: right;

            span {
              line-height: 1.3;
              display: inline-block;
              opacity: 0;
              transform: translateX(-4vw);
              transition: opacity $base-duration
                  cubic-bezier(0.645, 0.045, 0.355, 1) $base-duration,
                transform $base-duration cubic-bezier(0.645, 0.045, 0.355, 1)
                  $base-duration,
                color $base-duration cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
            }
            &:after {
              position: absolute;
              top: 50%;
              right: 0;
              width: 8px;
              height: 8px;

              content: "";
              transform: translate(24px, -50%);
              border-radius: 50%;
              background-color: $color-navigation;
              transition: all $base-duration
                cubic-bezier(0.645, 0.045, 0.355, 1);
            }
          }
          .menu-item-child {
            position: relative;
            margin-right: auto;
            margin-left: 40px;

            counter-reset: num;

            &.year {
              dd {
                &:before {
                  content: none;
                  padding-left: 0;
                }
              }
            }
            &:before {
              position: absolute;
              top: 0;
              left: 0;
              width: 2px;
              height: calc(100% - 6px);

              content: "";
              transform: translate(-41px, 21px);
              background: linear-gradient(to bottom, #9baecc, #9baecc);
              background-size: 100% 4px;
              transition: all $base-duration
                cubic-bezier(0.645, 0.045, 0.355, 1);
            }
            &:after {
              position: absolute;
              top: 0;
              left: 0;
              width: 2px;
              z-index: 10;
              height: calc(100% - 6px);

              content: "";
              transform: translate(-41px, 21px);
              background: linear-gradient(to bottom, $color-navigation);
              background-color: $color-navigation;
              transition: all $base-duration
                cubic-bezier(0.645, 0.045, 0.355, 1);
            }

            .menu-chapter {
              position: relative;

              font-size: 22px;
              line-height: 1.3;

              margin-bottom: 30px;
              letter-spacing: 2px;

              opacity: 0;
              transform: translateX(4vw);
              transition: opacity $base-duration
                  cubic-bezier(0.645, 0.045, 0.355, 1) $base-duration,
                transform $base-duration cubic-bezier(0.645, 0.045, 0.355, 1)
                  $base-duration,
                color $base-duration cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
            }
            dd {
              font-size: 16px;
              line-height: 1.3;

              margin-bottom: 12px;

              opacity: 0;
              transform: translateX(4vw);
              transition: all $base-duration
                cubic-bezier(0.645, 0.045, 0.355, 1);
              transition-delay: 500ms;
              &:last-of-type {
                margin-bottom: 50px;
              }
              &:hover {
                color: $color-navigation;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 1540px) {
    .menu-container {
      .menu-nav {
        width: 90%;
        left: 10%;

        .menu-list .menu-item .menu-item-child .menu-chapter {
          font-size: 20px;
        }
      }
    }
  }

  @media (max-width: $lg-max) {
    .menu-container .menu-nav .menu-list {
      width: 750px;
      max-width: 750px;
    }
  }
}
</style>
